module.exports = __webpack_public_path__ + "img/linkedin_link_title.485503ba.svg";